import palette from './palette'

const colors = {
  ...palette,

  primary: palette.primary,
  white: palette.white,
  black: palette.black,
  positive: palette.positive,
  positiveSecondary: palette.positiveDark,
  negative: palette.negative,
  warning: palette.warning,
  warningSecondary: palette.warningDark,
  secondaryBlack: palette.secondaryBlack,
  disabled: palette.gray,

  bg: {
    secondary: palette.grayDark,
    default: palette.white,
  },

  border: {
    tertiary: palette.smoke,
    secondary: palette.smokeLight,
    default: palette.grayLight,
  },

  font: {
    secondary: palette.gray,
    default: palette.grayDark,
    link: palette.dodgerBlue,
  },
}

export default colors
